export default __webpack_public_path__ + "static/investor-benefits-ab0019efd97239c3771cb50fdc57320e.jpg";